import { connect } from 'react-redux';
import { showFavouritedByModal } from '../Modals/redux/actionCreators';
import { getUserStreamContents } from './redux/selectors';
import { initializeUserStream } from './redux/actions';
var mapStateToProps = function (state, _a) {
    var deviation = _a.deviation, userListType = _a.userListType;
    return getUserStreamContents(state, userListType, deviation);
};
var mapDispatchToProps = {
    initialize: initializeUserStream,
    showFavouritedByModal: showFavouritedByModal,
};
export default connect(mapStateToProps, mapDispatchToProps);
//# sourceMappingURL=Who.container.js.map